<template>
  <v-col :cols="6" :md="opened ? 3 : 3" @mouseover="productHover">
    <div
      ref="productCard"
      v-bind:style="productCardStyle"
      :class="
        opened
          ? step > 2
            ? 'product-card-active product-card bg-white'
            : 'product-card-active product-card'
          : 'product-card'
      "
    >
      <div
        :class="
          step > 1
            ? 'product-card-image product-card-image-small'
            : 'product-card-image'
        "
      >
        <span
          v-if="step < 2"
          class="product-new-badge bg-danger text-white rounded"
        >
          {{ trans('New') }}
        </span>
        <span @click="closeProduct" class="material-icons product-close-button">
          close
        </span>
        <div class="product-card-slider">
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="image in product.images" :key="image.id">
              <img
                @click="productClicked"
                :src="
                  'https://s3.eu-north-1.amazonaws.com/tripsome.az-public/products/' +
                  image.image
                "
                class="w-100"
              />
            </swiper-slide>
            <div
              v-if="step < 2"
              class="product-swiper-pagination swiper-pagination"
              slot="pagination"
            ></div>
            <div v-if="step < 2" class="swiper-btn-prev" slot="button-prev">
              <span class="material-icons">keyboard_arrow_left</span>
            </div>
            <div v-if="step < 2" class="swiper-btn-next" slot="button-next">
              <span class="material-icons">keyboard_arrow_right</span>
            </div>
          </swiper>
        </div>
      </div>
      <div
        @click="productClicked"
        :class="
          step > 1
            ? 'product-card-info product-card-info-small'
            : 'product-card-info'
        "
      >
        <div class="product-name">{{ product.name }}</div>
        <div class="product-shipped-from">Ships from Bakı</div>
        <div v-show="opened" class="product-info" v-html="product.info"></div>
        <v-btn text color="primary" :href="`https://tripsome.az/${lang}/return-and-refund-policy`">{{ trans('return and refund policy') }}</v-btn>
      </div>
      <div v-if="step > 1" class="product-confirmation">
        <div v-if="step == 2" class="product-confirmation-header">
          <div class="product-confirmation-minimize">
            <span
              @click="previousStem"
              class="material-icons product-information-minimize-button"
            >
              keyboard_arrow_down
            </span>
          </div>
          <div class="product-confirmation-title">Buy Now</div>
        </div>
        <div class="product-confirmation-container">
          <div
            class="product-confirmation-section product-confirmation-section-flex"
            v-if="step == 2"
          >
            <div class="product-confirmation-section-title float-left">
              {{ trans('quantity') }}
              <span>₼ {{ product.price }} per unit</span>
            </div>
            <div class="product-confirmation-section-input">
              <number-input
                v-if="opened"
                @change="updateQuantity"
                :inputValue="order.quantity"
                min="1"
                :max="product.stock"
              ></number-input>
            </div>
          </div>

          <div
            class="product-confirmation-section product-confirmation-section-flex"
            v-if="step == 2 && user && user.balance > 0"
          >
            <div class="product-confirmation-section-title float-left">
              {{ trans('wallet') }}
              <span>₼ {{ user.balance }} Available to use</span>
            </div>
            <div class="product-confirmation-section-input">
              <v-switch
                :hide-details="true"
                v-model="order.wallet"
                inset
              ></v-switch>
            </div>
          </div>

          <div
            v-if="step > 2"
            :class="
              status == 0
                ? 'product-payment-section'
                : 'product-payment-section product-payment-section-paid'
            "
          >
            <div class="product-payment-icon">
              <img
                :src="
                  status == 0
                    ? 'https://s3.eu-north-1.amazonaws.com/tripsome.az-public/resources/card-pos.svg'
                    : 'https://s3.eu-north-1.amazonaws.com/tripsome.az-public/resources/verify.svg'
                "
              />
            </div>
            <div class="product-payment-title">
              {{
                status == 1
                  ? 'Thank You for Shopping With Us'
                  : 'Awaiting Payment'
              }}
            </div>
            <div class="product-payment-loading">
              {{ status == 1 ? '' : '. . .' }}
            </div>
            <div class="product-payment-text">
              {{
                status == 1
                  ? 'An email has been sent to you, we will notify you via email on your delivery status '
                  : 'Please make your payment on the new tab that has opened up.'
              }}
            </div>
          </div>

          <div class="product-confirmation-section">
            <div class="product-confirmation-section-title">
              {{ trans('Order Summary') }}
              <div class="pl-2 pt-2">
                <span class="py-1">
                  ₼ {{ product.price }} Subtotal ({{ order.quantity }}x
                  quantity)
                </span>
                <span class="py-1">
                  ₼ {{ product.shipping_price }} Shipping fee
                </span>
                <span class="py-1">₼ 0 Balnace deduction</span>
                <span class="py-1 font-weight-bold">
                  ₼ {{ totalPrice }} Total
                </span>
              </div>
            </div>
          </div>

          <div class="py-7" v-if="step > 2"></div>

          <div class="product-confirmation-section mb-0" v-if="step == 2">
            <div class="product-confirmation-section-title">
              {{ trans('Delivery Information ') }}
            </div>
            <v-form ref="form" class="pt-2">
              <v-text-field
                v-model="order.address.address_1"
                outlined
                :label="trans('Street, City')"
                :rules="inputRules"
                dense
                required
                block
                hide-details
              ></v-text-field>
              <v-text-field
                v-model="order.address.address_2"
                outlined
                :label="trans('Building Name or No., Block No.')"
                :rules="inputRules"
                dense
                required
                block
                hide-details
              ></v-text-field>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="order.address.floor"
                    outlined
                    :label="trans('Floor')"
                    :rules="inputRules"
                    dense
                    required
                    block
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="order.address.house"
                    outlined
                    :label="trans('House No.')"
                    :rules="inputRules"
                    dense
                    required
                    block
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-text-field
                v-if="!user"
                v-model="order.email"
                outlined
                :label="trans('Email Address')"
                :rules="emailRules"
                dense
                required
                block
                hide-details
                type="email"
              ></v-text-field>
              <!-- <v-text-field
                v-model="order.phone"
                outlined
                :label="trans('Phone no.')"
                :rules="inputRules"
                dense
                required
                block
                hide-details
              ></v-text-field> -->
              <v-phone-field
                :label="trans('Phone no.')"
                :value="order.phone"
                @change="($event) => (order.phone = $event)"
                :rules="inputRules"
              ></v-phone-field>
              <v-checkbox
                v-model="order.saveAddress"
                value="1"
                :label="trans('Keep my delivery details for future orders')"
              ></v-checkbox>
            </v-form>
          </div>
        </div>
      </div>
      <div
        @click="productClicked"
        :class="
          step > 1
            ? 'product-price-container product-price-container-small'
            : 'product-price-container'
        "
        v-if="step < 3"
      >
        <div class="overflow-hidden">
          <div class="float-left">
            <div class="product-price text-primary">₼{{ subTotalPrice }}</div>
            <div class="product-shipping text-caption">
              + ₼{{ product.shipping_price }} shipping
            </div>
            <div class="product-price-arrow">
              <v-icon color="primary">mdi-arrow-right</v-icon>
            </div>
          </div>
          <number-input
            class="product-quantity"
            v-if="opened && step == 1"
            @change="updateQuantity"
            :inputValue="order.quantity"
            min="1"
            :max="product.stock"
          ></number-input>
        </div>
        <v-btn
          v-show="opened"
          @click="nextStep"
          class="mt-4"
          large
          block
          color="primary"
        >
          {{ trans('Buy Now') }}
        </v-btn>
      </div>
    </div>
  </v-col>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
  Mousewheel,
  Autoplay,
} from 'swiper/swiper.esm';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
import Vue from 'vue';

SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);

import 'swiper/swiper-bundle.min.css';

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      opened: false,
      step: 1,
      status: 0,
      order: {
        product: this.product,
        quantity: 1,
        wallet: false,
        address: {
          address_1: null,
          address_2: null,
          floor: null,
          house: null,
        },
        email: null,
        phone: null,
        saveAddress: false,
      },
      productCardStyle: {
        top: 0,
        left: 0,
      },
      images: [
        {
          id: 1,
          image:
            'https://media.istockphoto.com/id/1300459022/photo/natural-organic-spa-cosmetic-products-set-with-eucalyptus-leaves-top-view-herbal-skincare.jpg?s=170667a&w=0&k=20&c=XcQ8U4foAGaP4Ui8TkYX3lQSHu1pqOE57z8noa_FWmg=',
        },
        {
          id: 2,
          image:
            'https://www.themanual.com/wp-content/uploads/sites/9/2020/02/handmade-shoes-boots.jpg?fit=800%2C533&p=1',
        },
      ],
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
      },
      emailRules: [
        (value) => {
          if (value) return true;
          return 'E-mail is required.';
        },
        (value) => {
          if (/.+@.+\..+/.test(value)) return true;
          return 'E-mail must be valid.';
        },
      ],
      inputRules: [
        (value) => {
          if (value) return true;
          return 'Field is required.';
        },
      ],
    };
  },
  methods: {
    productClicked() {
      this.opened = true;
      this.$emit('overlay', true);
    },
    closeProduct() {
      this.step = 1;
      this.opened = false;
      this.order.quantity = 1;
      this.$emit('overlay', false);
    },
    async nextStep() {
      //validate 2ed step
      if (this.step == 2) {
        let valid = await this.validate();
        if (!valid) return;
      }

      this.step++;
      if (this.step == 3) {
        //generate payment url
        let response = await axios.post('/en/shop/payment-url', {
          ...this.order,
        });
        let url = response.data.redirect;
        if (url == 'wallet') {
          this.status = 1;
        } else {
          this.order.id = response.data.product_order_id;
          window.open(url, '_blank');
        }
      }
    },
    async validate() {
      return await this.$refs.form.validate();
    },
    previousStem() {
      this.step--;
    },
    productHover() {
      let left = this.$refs.productCard.getBoundingClientRect().left;
      let top = this.$refs.productCard.getBoundingClientRect().top;
      this.productCardStyle.left = left + 'px';
      this.productCardStyle.top = top + 'px';
    },
    updateQuantity(value) {
      this.order.quantity = value.count;
    },
  },
  computed: {
    subTotalPrice() {
      return this.order.quantity * this.product.price;
    },
    totalPrice() {
      return this.subTotalPrice + parseInt(this.product.shipping_price);
    },
    lang() {
      return window.lang;
    },
  },
  mounted() {
    let left = this.$refs.productCard.getBoundingClientRect().left;
    let top = this.$refs.productCard.getBoundingClientRect().top;
    this.productCardStyle.left = left + 'px';
    this.productCardStyle.top = top + 'px';

    document.addEventListener('visibilitychange', async () => {
      if (!document.hidden && this.step == 3) {
        let response = await axios.post('/en/shop/payment-status', {
          ...this.order,
        });
        this.status = response.data;
      }
    });
  },
  components: {
    Swiper,
    SwiperSlide,
  },
};
</script>
<style scoped>
.product-card,
.product-card div {
  transition: all 400ms cubic-bezier(0.51, 1.56, 0.43, 0.86);
  /* transition: all 400ms cubic-bezier(0.34, 1.56, 0.64, 1); */
}
.product-card {
  padding-bottom: 44px;
  background: white;
  cursor: pointer;
}
.product-card:hover .product-name {
  color: #0078cc;
}
.product-card:hover .product-price-arrow {
  right: 0px;
}
.swiper-btn-prev,
.swiper-btn-next {
  background: rgba(26, 27, 30, 0.7);
  color: white;
  border: 0;
  font-size: 26px;
  width: 32px;
  height: 32px;
  top: unset;
  bottom: 8px;
}
.swiper-pagination {
  max-width: calc(100% - 96px);
  margin: auto;
  left: 0;
  right: 0;
}
.swiper-slide img {
  aspect-ratio: 1.5;
  object-fit: cover;
}
.swiper-container {
  border-radius: 8px;
  overflow: hidden !important;
}
.product-new-badge {
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  z-index: 3;
  left: 8px;
  top: 8px;
}

.product-card-image {
  position: relative;
  background: white;
}
.product-card-info {
  padding-top: 12px;
  position: relative;
  background: white;
}

.product-name {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.product-shipped-from {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.product-price {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.product-shipping {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
.product-price-arrow {
  width: fit-content;
  position: absolute;
  bottom: 12px;
  right: 6px;
}
.product-price-container {
  position: relative;
}
.product-card-active {
  position: fixed;
  top: 30px !important;
  /* left: -30px !important; */
  z-index: 9999;
  max-height: calc(100vh - 60px);
  background: #ffffffa1;
  border-radius: 8px;
  padding: 0px;
  padding-bottom: 0 !important;
  /* transform: scale(1.3) translateY(-140px); */
  width: 368px;
  overflow: hidden scroll;

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.product-card-active::-webkit-scrollbar {
  display: none;
}

.product-card-active .product-card-info {
  padding: 16px;
  position: unset;
}
.product-card-active .swiper-pagination {
  bottom: -35px;
  filter: invert(1) contrast(1);
}

.product-card-active .product-card-slider {
  padding-bottom: 48px;
}

.product-card-active .swiper-container {
  overflow: visible;
}

.product-card-active .swiper-btn-prev {
  bottom: -40px;
  filter: invert(1) contrast(1);
  background: none;
}
.product-card-active .swiper-btn-next {
  bottom: -40px;
  filter: invert(1) contrast(1);
  background: none;
}
.product-card-active .product-name {
  font-size: 24px;
  font-weight: 600;
  color: black !important;
}

.product-card-active .product-shipped-from {
  font-size: 16px;
  line-height: 24px;
}
.product-card-active .product-price-container {
  position: sticky;
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 16px;
  padding-top: 12px;
  border-top: 1px solid #0000001f;
  background: white;
}

.product-card-active .product-price-container-small {
  display: flex;
  align-items: center;
}
.product-price-container-small > div,
.product-price-container-small > button {
  flex: 1;
}
.product-price-container-small > button {
  min-width: fit-content !important;
  margin-top: 0 !important;
}

.product-card-active .product-price-arrow {
  display: none;
}
.product-card-active .swiper-slide {
  width: 100% !important;
}
.product-card-active .product-price {
  font-size: 20px;
  line-height: 26px;
}
.product-card-active .product-quantity {
  float: right;
  width: auto;
  margin: 2px 0;
}
.product-close-button {
  display: none;
}
.product-card-active .product-close-button {
  display: block;
  padding: 8px;
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  z-index: 3;
  right: 12px;
  top: 12px;
  background: rgba(26, 27, 30, 0.7);
  border-radius: 50px;
  color: white;
}
.product-info {
  padding-top: 12px;
}
.product-card-image-small img {
  width: 40px !important;
  height: 40px;
  overflow: hidden;
  margin: 8px 16px;
  border-radius: 8px;
}
.product-card-image-small .product-card-slider {
  margin: 0;
  padding: 0;
}
.product-card-image-small {
  background: none;
}
.product-card-info-small {
  position: absolute !important;
  z-index: 4;
  top: 0;
  padding: 8px !important;
  padding-left: 70px !important;
  background: none;
}

.product-card-info-small .product-info {
  display: none;
}

.product-card-info-small .product-name {
  font-size: 14px !important;
  line-height: 20px !important;
}

.product-shipped-from {
  font-size: 14px !important;
  line-height: 20px !important;
}
.product-confirmation {
  background: white;
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
}
.product-information-minimize-button {
  padding: 4px;
}

.product-confirmation-title {
  line-height: 56px;
  font-size: 20px;
  font-weight: 500;
}

.product-confirmation-minimize {
  float: left;
  margin: 12px;
  display: flex;
}
.product-confirmation-header {
  border-bottom: 1px solid #0000001f;
}
.product-confirmation-section {
  margin-bottom: 32px;
  overflow: visible;
}

.product-confirmation-container {
  padding: 16px;
}
.product-confirmation-section-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.product-confirmation-section-input {
  float: right;
}

.product-confirmation-section-title span {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  display: block;
}
.product-confirmation-section-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.product-confirmation-section .v-input {
  padding: 6px 0;
}
.product-payment-icon {
  width: 64px;
  height: 64px;
  padding: 16px;
  border-radius: 100px;
  background: rgba(255, 149, 1, 0.12);
  margin: auto;
  margin-top: 64px;
  margin-bottom: 24px;
}

.product-payment-icon img {
  object-fit: contain;
  width: 100%;
}

.product-payment-title {
  text-align: center;
  /* headline/medium */
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
}

.product-payment-text {
  color: black;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  opacity: 0.64;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.product-payment-loading {
  text-align: center;
  font-size: 40px;
  line-height: 40px;
  margin-top: 8px;
  margin-bottom: 24px;
}
.product-payment-section-paid .product-payment-icon {
  background: rgba(0, 115, 229, 0.12);
}

@media (max-width: 650px) {
  .swiper-pagination {
    max-width: 100%;
  }
  .product-card-active {
    left: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    max-height: calc(100vh - 30px) !important;
    border-radius: 8px 8px 0 0 !important;
  }
}
</style>
<style>
.product-swiper-pagination .swiper-pagination-bullet-active {
  background: white;
}
.swiper-pagination-bullet {
  border: 1px solid white;
}
.c-number-input-cont {
  margin-bottom: 0;
}
.c-number-input-lable {
  padding-right: 0px;
}
</style>
